import BaseComponentController from '.././base-component.controller';

class ForeignInterferenceQuestionController extends BaseComponentController {
    constructor(_, componentRegistryService, $q, constants) {
        super(_, componentRegistryService, $q);
        this.vm = {
            errors: []
        };
        this.constants = constants;
    }

    init() {
        this.vm = {
            errors: [],
            isValid: !this.required || !this._.isEmpty(this.model)
        };

        this.initQuestionResponses();
    }

    getNewResponse() {
        return {
            'countryName': null,
            'organisationName': null,
            'associationSummary': null,
            'foreignAssociationType': this.foreignAssociationType
        };
    }

    initQuestionResponses() {
        if (this.model.questionResponses == null) {
            this.model.questionResponses = [this.getNewResponse()];
        }
    }

    questionResponsesValid() {
        if (this.model.questionResponses == null || this.model.questionResponses.length === 0) {
            return false;
        }

        if (this.model.questionResponses.some(response => this.isQuestionResponseInvalid(response))) {
            return false;
        }

        return true;
    }

    isQuestionResponseInvalid(response) {
        return this.isEmpty(response.countryName) || this.isEmpty(response.organisationName) || this.isEmpty(response.associationSummary);
    }

    isEmpty(str) {
        return (!str || str.length === 0);
    }

    validState() {
        return this.vm.isValid;
    }

    validate() {
        if (this.readonly) {
            return true;
        }

        if (this.required === true) {
            if (this.model.questionBool == null || (this.model.questionBool === true && this.hasQuestions === true && this.questionResponsesValid() === false)) {
                this.vm.isValid = false;
                this.vm.errors = [`Please complete this question before continuing.`];
            } else {
                this.vm.errors = [];
                this.vm.isValid = true;
            }
        }

        return this.vm.errors.length === 0;
    }

    validateAsync() {
        return this.getPromise(this.validate());
    }

    radioItemSelected() {
        this.vm = {
            errors: []
        };

        this.validate();

        this.initQuestionResponses();
    }

    addNewResponse() {
        this.initQuestionResponses();
        this.model.questionResponses.push(this.getNewResponse());
    }
}

ForeignInterferenceQuestionController.$inject = ['_', 'componentRegistryService', '$q', 'constants'];

let foreignInterferenceQuestionComponent = {
    controller: ForeignInterferenceQuestionController,
    bindings: {
        readonly: '<',
        required: '<',
        referNextQuestionVisible: '<',
        hasQuestions: '<',

        model: '=',

        questionText: '@',
        textInput1: '@',
        textInput2: '@',
        textInput3: '@',
        referQuestionText: '@',
        foreignAssociationType: '@'
    },
    templateUrl: `app/components/foreign-interference-question/foreign-interference-question.html`
};

export default foreignInterferenceQuestionComponent;

/*
    Model field names:
        hasQuestions(bool) - does this question have subquestions(e.g country / org / summary details)
        referNextQuestionVisible(bool - if true - negate if need false)
        model - one per question object:
            questionBool(bool) - field representing the true / false question response
            questionResponses(object) - ignored if hasQuestions === false
                countryName
                organisationName
                associationSummary
                foreignAssociationType

    Static text (from constants):
        questionText
        textInput1
        textInput2
        textInput3
        referQuestionText
        foreignAssociationType
*/


// WEBPACK FOOTER //
// ./app/components/foreign-interference-question/foreign-interference-question.component.js